<template>
  <Header/>
  <div class="one center">
    <!--幻灯片-->
    <div class="one_left fl">
      <div class="hd">
        <ul>
          <li class="dj"><a>$</a></li>
        </ul>
      </div>
      <div class="hdp">
        <ul>
          <li>
            <img :src="banner[bannerI].img" :alt="banner[bannerI].title"/>
            <h1 style="font-size:17px;">
              {{ banner[bannerI].title }}
            </h1>
          </li>
        </ul>
      </div>
    </div>
    <!--新闻中心-->
    <div class="one_center fl">
      <div class="title">
        <a href="/#/huiYuanZhongXin" title="会员中心"><h1>会员中心</h1></a>
      </div>
      <ul>
        <li class="inner" v-for="(item, index) in dataList.huiYuanZhongXin" :key="index">
          <a :href="'/#/detail?id=' + item.ID" :title='item.post_title'
             class="inner-flex">{{ item.post_title }}</a>
          <span class="inner-span">{{ item.post_date.split(" ")[0] }}</span>
        </li>
      </ul>
    </div>
    <div class="one_right fl">
      <div class="title" style="margin-bottom: 10px;">
        <a href="/#/xieHuiGaiKuang" title="协会概况"><h1>协会概况</h1></a>
      </div>
      <ul>
        <li class="inner" v-for="(item, index) in dataList.xieHuiGaiKuang" :key="index">
          <a :href="'/#/detail?id=' + item.ID" :title='item.post_title'
             class="inner-flex">{{ item.post_title }}</a>
          <span class="inner-span">{{ item.post_date.split(" ")[0] }}</span>
        </li>
      </ul>
    </div>

    <div style="clear: both"></div>
  </div>

  <div class="two center">
    <!--政策法规-->
    <div class="two_ul fl">
      <div class="titles">
        <a href="/#/xinWenZiXun" title="新闻资讯"><h1>新闻资讯</h1></a>
        <a href="/#/xinWenZiXun" class="more">MORE+</a>
      </div>
      <ul>
        <li class="inner" v-for="(item, index) in dataList.xinWenZiXun" :key="index">
          <a :href="'/#/detail?id=' + item.ID" :title='item.post_title'
             class="inner-flex">{{ item.post_title }}</a>
          <span class="inner-span">{{ item.post_date.split(" ")[0] }}</span>
        </li>
      </ul>
    </div>
    <!--行业动态-->
    <div class="two_ul two_center fl">
      <div class="titles">
        <a href="/#/hangYeDongTai" title="行业动态"><h1>行业动态</h1></a>
        <a href="/#/hangYeDongTai" class="more">MORE+</a>
      </div>
      <ul>
        <li class="inner" v-for="(item, index) in dataList.hangYeDongTai" :key="index">
          <a :href="'/#/detail?id=' + item.ID" :title='item.post_title'
             class="inner-flex">{{ item.post_title }}</a>
          <span class="inner-span">{{ item.post_date.split(" ")[0] }}</span>
        </li>
      </ul>
    </div>
    <!--组织机构-->
    <div class="two_ul fl">
      <div class="titles">
        <a href="/#/xinXiZhongXin" title="信息中心"><h1>信息中心</h1></a>
        <a href="/#/xinXiZhongXin" class="more">MORE+</a>
      </div>
      <ul>
        <li class="inner" v-for="(item, index) in dataList.xinXiZhongXin" :key="index">
          <a :href="'/#/detail?id=' + item.ID" :title='item.post_title'
             class="inner-flex">{{ item.post_title }}</a>
          <span class="inner-span">{{ item.post_date.split(" ")[0] }}</span>
        </li>
      </ul>
    </div>
    <div style="clear: both"></div>
  </div>

  <Footer/>
</template>

<script>
// @ is an alias to /src

import Header from "@/components/Header"
import Footer from "@/components/Footer"
import http from "@/util/http"

export default {
  name: 'HomeView',
  components: {
    Footer,
    Header
  },
  data() {
    return {
      interval: undefined,
      bannerI: 0,
      dataList: {},
      banner: [
        {
          id: 0,
          img: 'images/201910181123106208.png',
          title: '中国工程师协会欢迎您的到来'
        },
        {
          id: 1,
          img: 'images/201910181125366969.jpeg',
          title: '中国工程师协会欢迎您的到来'
        }
      ]
    }
  },
  mounted() {
    this._scroll()
    this._getList()
  },
  unmounted() {
    this.interval && clearInterval(this.interval)
  },
  methods: {
    _scroll() {
      this.interval = setInterval(() => {
        if (this.bannerI >= this.banner.length - 1) {
          this.bannerI = 0
        } else {
          this.bannerI = this.bannerI + 1
        }
      }, 3000)
    },
    _getList() {
      http.get('homePage')
          .then((res) => {
            if (res.data.status === 0) {
              this.dataList = res.data.data
            }
          })
    },
  }
}
</script>
<style scoped>
h1 {
  font-weight: bold;
}

.aa {
  color: #666666;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.bb {
  color: #666666;
}

.inner {
  width: 355px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.inner-flex {
  flex: 1;
  color: #666666;
  font-weight: bold;
  display: table-cell;
  vertical-align: middle;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  line-height: 14px;
  height: 14px;
}
.inner-width {
  width: 386px;
}
.inner-span {
  width: 85px;
  font-size: 14px;
  font-weight: 1.5;
}
</style>
